import { type UserClaims } from '@airship-platform/airship-auth';

export const roleHomePaths: Record<UserClaims['userRole'], string> = {
  TECHNICIAN: '/service-management/schedule',
  OWNER: '/proposal-insights',
  AIRSHIP_ADMIN: '/airship-admin',
};
